var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tooltip',{attrs:{"placement":"top"}},[(_vm.text === '计费异常' && _vm.desc)?_c('template',{slot:"title"},[_c('p',[_vm._v(" "+_vm._s(_vm.desc)+" ")])]):_vm._e(),_c('span',{class:_vm.type + ' statusTag'},[_vm._v(_vm._s(_vm.text))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }